import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { requestServices } from '../requestServices'
import { PaymentLinkClaimPayload } from '../requestTypes'
import { QUERY_KEYS } from '@/constants/queryKeys'

export const useGetPaymentLinkInfo = (code: string, enabled = true) => {
  return useQuery({
    queryKey: [QUERY_KEYS.PAYMENT_LINK_INFO, code],
    queryFn: () => requestServices.getPaymentLinkInfo(code),
    enabled: !!code && enabled,
    retry: 1,
  })
}

export const useClaimPaymentLink = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (payload: PaymentLinkClaimPayload) =>
      requestServices.claimPaymentLink(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.PAYMENT_REQUESTS_HISTORY],
      })
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.WALLET] })
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.TRANSACTIONS] })
    },
  })
}
